<template>
  <button
    @click="toggle"
    :class="value ? 'bg-azuloscuro text-white' : 'bg-white text-azuloscuro'"
    class="rounded-lg mr-4 focus:outline-none"
  >
    <img v-if="type === 'video' && !value" src="@/assets/images/Filtros/video2.svg" style="width: 25px" />
    <img v-if="type === 'video' && value" src="@/assets/images/Filtros/video1.svg" style="width: 25px" />
    <img v-if="type === 'pdf' && !value" src="@/assets/images/Filtros/pdf2.svg" />
    <img v-if="type === 'pdf' && value" src="@/assets/images/Filtros/pdf2.2.svg" />
    <img v-if="type === 'audio' && !value" src="@/assets/images/Filtros/audio1.svg" />
    <img v-if="type === 'audio' && value" src="@/assets/images/Filtros/audio2.svg" />
    <img v-if="type === 'text' && !value" src="@/assets/images/Filtros/text1.svg" />
    <img v-if="type === 'text' && value" src="@/assets/images/Filtros/text2.svg" />
    <img v-if="type === 'image' && !value" src="@/assets/images/Filtros/Image1.svg" style="width: 25px" />
    <img v-if="type === 'image' && value" src="@/assets/images/Filtros/Image2.svg" style="width: 25px" />
  </button>
</template>

<script>
export default {
  props: ['type', 'value'],
  methods: {
    toggle() {
      this.$emit('input', !this.value)
    }
  }
};
</script>

<style scoped>
  img {
    width: 20px;
    display: inline;
  }

  button {
    display: inline-block;
    width: 50px;
    height: 50px;
    text-align: center;
  }
</style>
